import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Subscription } from 'rxjs'
import { BrandsList } from '../../models/brands.model'
import { ActivationStatus } from 'src/app/shared/enums/general.enum'
import { AddEditBrandComponent } from '../add-edit-brand/add-edit-brand.component'
import { MatDialog } from '@angular/material/dialog'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'
import { TranslateService } from '@ngx-translate/core'
import { StoreService } from '../../services/store.service'
import { environment } from 'src/environments/environment'

@Component({
	selector: 'app-brands-table',
	templateUrl: './brands-table.component.html',
	styleUrls: ['./brands-table.component.scss'],
})
export class BrandsTableComponent implements OnInit {
	@Input() brands: BrandsList[] = []
	@Input() brandsFilter: any = {
		paging: { pageNumber: 1, pageSize: 10 },
		searchText: '',
	}
	@Input() totalCount = 0
	@Output() activationState: EventEmitter<any> = new EventEmitter()
	@Output() deleteId = new EventEmitter<number>()
	@Output() actionChanged: EventEmitter<any> = new EventEmitter()
	subscription = new Subscription()
	statusEnum = ActivationStatus
	br: any
	attachmentUrl = environment.attachmentPath
	constructor(
		private dialog: MatDialog,
		public translate: TranslateService,
		private brandService: StoreService
	) {}

	ngOnInit(): void {}

	EditBrand(brand: BrandsList) {
		this.dialog
			.open(AddEditBrandComponent, {
				width: '600px',

				data: {
					formEditedData: {
						enName: brand?.name?.en,
						arName: brand?.name?.ar,
						imageUrl: brand?.imageUrl,
					},
					typeTitle: 'brand',
					title: 'ACTIONS.EDIT_BRAND',
					label: 'STORE.BRANDS_LIST.ENGLISH_NAME',
					label2: 'STORE.BRANDS_LIST.ARABIC_NAME',
					editBrand: true,
					confirmBtn: 'ACTIONS.EDIT',
					cancelBtn: 'ACTIONS.CANCEL',
					hasImg: true,
				},

				autoFocus: false,
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						let data = {
							id: brand.id,
							name: {
								en: res.f1,
								ar: res.f2,
							},
							isActive: brand.isActive,
							imageUrl: res.f3,
						}
						this.subscription.add(
							this.brandService.updateBrandStatus(data).subscribe((res) => {
								this.actionChanged.emit()
							})
						)
					}
				},
			})
	}

	deleteBrand(brandData: BrandsList) {
		this.dialog
			.open(ConfirmationMessageComponent, {
				width: '416',
				height: '360',
				data: {
					message: this.translate.instant('CONFIRMATION_MESSAGE.DELETE_BRAND', {
						name:
							this.translate.currentLang == 'ar'
								? brandData?.name?.ar
								: brandData?.name?.en,
					}),
					typeTitle: 'brand',
					title: `${this.translate.instant('ACTIONS.DELETE')}${' '}${
						this.translate.currentLang == 'ar'
							? brandData?.name?.ar
							: brandData?.name?.en
					}`,
					notflex: true,
					cancelBtn: 'ACTIONS.CANCEL',
					confirmBtn: 'ACTIONS.DELETE',
					confirmBtnStyle: `text-off-white bg-[#B3261E] h-[52px]`,
					msgStyle: 'text-[14px] text-[#6E7191] w-[450px]',
					titleStyle:
						'ltr:font-DIN-bold font-bold rtl:font-semibold text-[24px] text-[#4E4B66]',
					cancelBtnStyle: ` border-[1px] border-secondry-color-Gray h-[52px] text-dark-grey border-solid`,
				},
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						this.deleteId.emit(brandData.id)
					}
				},
			})
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
